const { getBootstrapData } = require('@swa-ui/bootstrap');
const { logger } = require('@swa-ui/log');
const settings = require('swa-app-config/env-settings');

const configureNextGenLogger = () => {
    const apiKey = getBootstrapData('api-keys')?.[settings.environment];

    logger.init({ apiKey, appId: 'corporate-landing-home-page', channelId: 'swabiz' });
};

module.exports = { configureNextGenLogger };
